import axios from 'axios';

export function postRequestCargo(cargoRequest) {
    return axios({
        method: 'POST',
        url: '/api/v1/requests/cargo',
        withCredentials: true,
        data: cargoRequest,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function changeUserCargoRequest(cargoRequestId, userId) {
    return axios({
        method: 'put',
        url: `/api/v1/requests/cargo/${cargoRequestId}/changeOwner`,
        withCredentials: true,
        data: {
            user: userId,
        },
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function deleteCargoRequest(cargoRequestId) {
    return axios({
        method: 'delete',
        url: `/api/v1/requests/cargo/${cargoRequestId}`,
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function getCargoMonitor(filter) {
    return axios({
        method: 'post',
        url: '/api/v1/deck/admin/cargo',
        withCredentials: true,
        data: {
            page: filter.page || 1,
            filters: filter.filters || {},
        },
    })
        .then(response => response.data)
        .catch(response => response.data);
}



// WEBPACK FOOTER //
// ./app/services/cargoes/requests.js